import { useEffect } from 'react';

export function hasNativeEmployerSectionMenu(): boolean {
  if (typeof window === 'undefined') return false;
  const bridge = (window as unknown as {
    QuantisNativeBridge?: { hasNativeEmployerSectionMenu?: boolean | (() => boolean) };
  }).QuantisNativeBridge;
  const capability = bridge?.hasNativeEmployerSectionMenu;
  try {
    return typeof capability === 'function' ? capability.call(bridge) === true : capability === true;
  } catch { return false; }
}

export function useNativeEmployerSectionMenu(activeSection: string, profileOpen: boolean): boolean {
  const enabled = profileOpen && hasNativeEmployerSectionMenu();
  useEffect(() => {
    if (!enabled) return;
    window.dispatchEvent(new CustomEvent('native:section-menu-state', {
      detail: { view: 'employers', activeId: activeSection, rootId: 'details' },
    }));
    return () => { window.dispatchEvent(new CustomEvent('native:section-menu-state', { detail: null })); };
  }, [enabled, activeSection]);
  return enabled;
}
